/* ==========================================================================
   STR8 ANCHOR SCROLL v1.0

   Same-page hash links (the announcement bar to #join-the-list, and any
   future "back to X" link) landing scroll-into-view by script rather than
   relying on the browser's native fragment scroll.

   The native behaviour runs once, early in the load sequence, and does not
   retry once hero images or self-hosted fonts finish arriving and shift the
   layout beneath it. On a page as image-heavy as this one that made the
   landing spot unreliable. Explicit control here means one deliberate scroll,
   timed after paint, with the sticky header height already accounted for via
   each target's own scroll-margin-top.

   Handles two cases:
     1. A click on any in-page a[href^="#"] whose target exists on the
        current page.
     2. A hash already present in the URL when the page loads, for a shared
        link or a bookmark.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__str8AnchorScrollLoaded) return;
  window.__str8AnchorScrollLoaded = true;

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function go(target) {
    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;

    var hash = link.getAttribute('href');
    if (!hash || hash === '#') return;

    var target = document.getElementById(hash.slice(1));
    if (!target) return;

    e.preventDefault();
    if (history.pushState) history.pushState(null, '', hash);
    go(target);
  });

  if (location.hash.length > 1) {
    var initial = document.getElementById(location.hash.slice(1));
    if (initial) {
      /* Deferred a frame so hero images already in the layout have applied
         their reserved dimensions before the scroll runs. */
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          go(initial);
        });
      });
    }
  }
})();
